import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VotrePartenaireEnSolutionsComplexes from "./sections/VotrePartenaireEnSolutionsComplexes";
import SolutionsPourDossiersComplexes from "./sections/SolutionsPourDossiersComplexes";
import VosSolutionsSurMesure from "./sections/VosSolutionsSurMesure";
import LExpertiseJennyMartel from "./sections/LExpertiseJennyMartel";
import HistoiresDeSuccS from "./sections/HistoiresDeSuccS";
import RPonsesVosQuestions from "./sections/RPonsesVosQuestions";
import PrTTransformerVotreSituation from "./sections/PrTTransformerVotreSituation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VotrePartenaireEnSolutionsComplexes />
      <SolutionsPourDossiersComplexes />
      <VosSolutionsSurMesure />
      <LExpertiseJennyMartel />
      <HistoiresDeSuccS />
      <RPonsesVosQuestions />
      <PrTTransformerVotreSituation />
      <Footer />
    </div>;
}